import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

const sharedOptionProps = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-start',
  boxSizing: 'border-box'
};

export const DROPDOWN_OPTION = cxs({
  ...sharedOptionProps,
  padding: '10px 20px',
  cursor: 'pointer',
  position: 'relative',
  minHeight: '45px',

  ':hover:after': {
    content: '""',
    background: COLOURS.cyan.jungleGreen.monkeyLight,
    position: 'absolute',
    left: '10px',
    top: '5px',
    width: 'calc(100% - 20px)',
    height: 'calc(100% - 10px)',
    zIndex: -1,
    borderRadius: '8px'
  }
});

export const DROPDOWN_VALUE = cxs(sharedOptionProps);

export const DROPDOWN_LABEL = cxs({
  display: 'flex',
  alignItems: 'center',

  ' >:first-child:not(:only-child)': {
    marginRight: '10px'
  }
});